import React, { MouseEvent } from 'react';
import styled from 'styled-components';

export interface CardDescriptionProps {
  description: string;
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
  characterLimit?: number;
  className?: string;
  'data-cy'?: string;
  showMoreDataCy?: string;
}

const DescriptionContainer = styled.div`
  align-self: stretch;
  position: relative;
  line-height: 1.5;
  cursor: pointer;
  color: #414042;
  width: 100%;
  overflow-wrap: break-word;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
  min-height: 80px;
  flex-grow: 1;
`;

const DescriptionText = styled.span``;

const ShowMore = styled.span`
  font-weight: 600;
  color: #0077a0;
  margin-left: 4px;
  height: 100%;
  &:hover {
    text-decoration: underline;
  }
`;

const CardDescription: React.FC<CardDescriptionProps> = ({
  description,
  onClick,
  characterLimit = 80,
  className,
  'data-cy': dataCy,
  showMoreDataCy,
}) => {
  const shouldTruncate = description.length > characterLimit;
  const displayDescription = shouldTruncate
    ? `${description.substring(0, characterLimit)}...`
    : description;

  return (
    <DescriptionContainer
      className={className}
      onClick={onClick}
      data-cy={dataCy}
    >
      <DescriptionText>{displayDescription}</DescriptionText>
      {shouldTruncate && (
        <ShowMore data-cy={showMoreDataCy}>Show more</ShowMore>
      )}
    </DescriptionContainer>
  );
};

export default CardDescription;
